import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Webcam from "react-webcam";
import moment from "moment";
import {
    setAlertMessageSnackbarMessageSeverity,
    setAlertMessageSnackbarMsg,
    setAlertMessageSnackbarOpen,
} from "../store/feedback";

import { useLocation, useNavigate } from "react-router-dom";
import "./style.css";
import "./camera.css";
import axios from "axios";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@mui/material";

import carImage from "./new-img.png";

import { Modal } from 'antd';
import FileContext from "../context/Context";
import { SnackbarAlert } from "../custom-component/AlertMessage";
import InspectionSteps from "./InspectionSteps";
import { Box, Typography, keyframes } from "@mui/material";
import ImageProgressBarRetake from "./ImageProgressBarRetake";
import CustomToastify from "./custom-notified-msg/CustomToastify";
import { set_image_upload_status_retake } from "../store/image_upload_retake";
import { useFullscreen } from "../context/FullScreenContext";
import CustomVideoToastify from "./custom-notified-msg/CustomVideoToastify";
import VideoTimer from "../video-module/video-timer/VideoTimer";
import Photo_Video_Instruction from "./photo_video_instruction/Photo_Video_Instruction";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

const CameraRetake = () => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [videoCaptured, setVideoCaptured] = useState(false);
    const { requestFullscreen, isFullscreen } = useFullscreen();
    const [showInstructionPage, setShowInstructionPage] = useState(false);
    const [dialogWidth, setDialogWidth] = useState("29vw");
    const [dialogText, setDialogText] = useState("0.9rem");
    const [btnType, setBtnType] = useState(true);
    const timerRef = useRef(31); // Ref to store elapsed time
    const intervalRef = useRef(null);
    const isIOS = () => {
        return (
            /iPhone|iPad|iPod/i.test(navigator.userAgent) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
        );
    };
    const cameraContainerRef = useRef(null);
    const landscape = `${process.env.PUBLIC_URL}/inspection-icons/landscapeMode.svg`;
     const reload = "../camera-module/Reload.png";
    const correct = `${process.env.PUBLIC_URL}/custom-icons/correct.png`;
    const cameraOption = `${process.env.PUBLIC_URL}/inspection-images/camera-option.png`;
    const [capturedTime, setCapturedTime] = useState(null);
    const [hasRetaken, setHasRetaken] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    let [bodyType, setBodyType] = useState("SUV")
    const { audit_id } = useParams();


    const [image, setImage] = useState(null);
    const webcamRef = useRef(null);
    const [showImage, setShowImage] = useState(false);
    const [imageCaptured, setImageCaptured] = useState(false);
    const [showCamera, setShowCamera] = useState(false);
    const [numberOfCameras, setNumberOfCameras] = useState(0);
    const [activeDeviceId, setActiveDeviceId] = useState(undefined);
    const [devices, setDevices] = useState([]);
    const [imageBuffer, setImageBuffer] = useState(null)
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
    const containerRef = useRef(null);
    const navigate = useNavigate();
    const [isInLandscapeMode, setIsInLandscapeMode] = useState(
        window.screen.orientation.type
    );
    //stencils
    let stencilFolder = null;

    // Get userId from localStorage
    const insuranceUser = JSON.parse(localStorage.getItem('insuranceUser'));
    const userId = insuranceUser?.userId;
    console.log("User ID:", userId);
    const lowerBodyType = bodyType?.toLowerCase();

    if (lowerBodyType === 'suv') {
        stencilFolder = 'stencil-img-suv';
    } else if (lowerBodyType === 'muv') {
        stencilFolder = 'stencil-img-muv';
    } else if (lowerBodyType.includes('hatch back')) {
        stencilFolder = 'stencil-img-hatchback';
    } else if (lowerBodyType.includes('sedan')) {
        stencilFolder = 'stencil-img-sedan';
    }
    // console.log("125",lowerBodyType);
    console.log("stencil folder", stencilFolder);

    const car_front_side = `${process.env.PUBLIC_URL}/${stencilFolder}/car-front-side.png`;
    const car_front_left_side = `${process.env.PUBLIC_URL}/${stencilFolder}/car-front-left-side.png`;
    const car_front_right_side = `${process.env.PUBLIC_URL}/${stencilFolder}/car-front-right-side.png`;
    const car_back_side = `${process.env.PUBLIC_URL}/${stencilFolder}/car-back-side.png`;
    const car_back_left_side = `${process.env.PUBLIC_URL}/${stencilFolder}/car-back-left-side.png`;
    const car_back_right_side = `${process.env.PUBLIC_URL}/${stencilFolder}/car-back-right-side.png`;
    const car_left_side = `${process.env.PUBLIC_URL}/${stencilFolder}/car-left-side.png`;
    const car_right_side = `${process.env.PUBLIC_URL}/${stencilFolder}/car-right-side.png`;

    const car_tyre = `${process.env.PUBLIC_URL}/stencil-img-sedan/tyre.png`;//4-tyres
    const car_RC = `${process.env.PUBLIC_URL}/stencil-img-sedan/RC.png`; //2(registraion & rc)
    const car_chassis = `${process.env.PUBLIC_URL}/stencil-img-sedan/chassis.png`;
    const car_odometer = `${process.env.PUBLIC_URL}/stencil-img-sedan/odometer.png`;
    const car_outer_windshield = `${process.env.PUBLIC_URL}/stencil-img-sedan/car-outer-windshield.png`;
    const car_inner_windshield = `${process.env.PUBLIC_URL}/stencil-img-sedan/car-inner-windshield.png`;
    const car_sunroof_ext = `${process.env.PUBLIC_URL}/sunroof-stencils/Sunroof-Ext-Stencil.png`;
    const car_sunroof_int = `${process.env.PUBLIC_URL}/sunroof-stencils/Sunroof-Int-Stencil.png`;


    const storedConfig = localStorage.getItem("inspectionConfiguration");
    // console.log("164", storedConfig);

    // Parse the stored JSON (handle null case with fallback)
    const inspectionConfig = storedConfig ? JSON.parse(storedConfig).inspection_config : null;
    // const inspectionConfig = storedConfig ? JSON.parse(storedConfig).inspection_config : {
    // 	selectedItems: [],
    // 	selectedMode: "photo",
    // 	selectedCount: 10
    // };
    console.log("270", inspectionConfig);

    const imagesToCapture = [
        {
            viewName: "Additional Image 1",
            imageName: "additional_image_1",
            imageStencils: car_front_side,
            mode: "photo",
            id: 1,
        },
        {
            viewName: "Additional Image 2",
            imageName: "additional_image_2",
            imageStencils: car_front_left_side,
            mode: "photo",
            id: 2,
        },
        {
            viewName: "Additional Image 3",
            imageName: "additional_image_3",
            imageStencils: car_left_side,
            mode: "photo",
            id: 3,
        },
        {
            viewName: "Additional Image 4",
            imageName: "additional_image_4",
            imageStencils: car_back_left_side,
            mode: "photo",
            id: 4,
        },
        {
            viewName: "Additional Image 5",
            imageName: "additional_image_5",
            imageStencils: car_back_side,
            mode: "photo",
            id: 5,
        },
        {
            viewName: "Additional Image 6",
            imageName: "additional_image_6",
            imageStencils: car_back_right_side,
            mode: "photo",
            id: 6,
        }
    ];


    // First 8 images are mandatory
    // const mandatoryImages = imagesToCapture.slice(0, 8);
    // const mandatoryImages = inspectionConfig
    // 	? imagesToCapture.slice(0, 8)
    // 	: imagesToCapture.filter(image => image.id !== 10 && image.id !== 16);
    const mandatoryImages = imagesToCapture;
    // if (inspectionConfig) {
    //     if (inspectionConfig.selectedItems?.includes("Front Side")) {
    //         mandatoryImages.push(imagesToCapture.find(image => image.imageName === "front_side"));
    //     }
    //     if (inspectionConfig.selectedItems?.includes("Front Left Side")) {
    //         mandatoryImages.push(imagesToCapture.find(image => image.imageName === "front_left_side"));
    //     }
    //     if (inspectionConfig.selectedItems?.includes("Left Side")) {
    //         mandatoryImages.push(imagesToCapture.find(image => image.imageName === "left_side"));
    //     }
    //     if (inspectionConfig.selectedItems?.includes("Back Left Side")) {
    //         mandatoryImages.push(imagesToCapture.find(image => image.imageName === "back_left_side"));
    //     }
    //     if (inspectionConfig.selectedItems?.includes("Back Side")) {
    //         mandatoryImages.push(imagesToCapture.find(image => image.imageName === "back_side"));
    //     }
    //     if (inspectionConfig.selectedItems?.includes("Back Right Side")) {
    //         mandatoryImages.push(imagesToCapture.find(image => image.imageName === "back_right_side"));
    //     }
    //     if (inspectionConfig.selectedItems?.includes("Right Side")) {
    //         mandatoryImages.push(imagesToCapture.find(image => image.imageName === "right_side"));
    //     }
    //     if (inspectionConfig.selectedItems?.includes("Front Right Side")) {
    //         mandatoryImages.push(imagesToCapture.find(image => image.imageName === "front_right_side"));
    //     }
    //     // Add conditional images based on selectedItems
    //     if (inspectionConfig.selectedItems?.includes("Windshield")) {
    //         mandatoryImages.push(
    //             imagesToCapture.find(image => image.imageName === "outer_windshield"),
    //             imagesToCapture.find(image => image.imageName === "inner_windshield")
    //         );
    //     }
    //     if (inspectionConfig.selectedItems?.includes("Tyres")) {
    //         mandatoryImages.push(
    //             imagesToCapture.find(image => image.imageName === "front_left_tyre"),
    //             imagesToCapture.find(image => image.imageName === "back_left_tyre"),
    //             imagesToCapture.find(image => image.imageName === "back_right_tyre"),
    //             imagesToCapture.find(image => image.imageName === "front_right_tyre")
    //         );
    //     }
    //     if (inspectionConfig.selectedItems?.includes("Video of RMP")) {
    //         mandatoryImages.push(imagesToCapture.find(image => image.imageName === "rpm_meter_video"));
    //     }
    //     if (inspectionConfig.selectedItems?.includes("Odometer")) {
    //         mandatoryImages.push(imagesToCapture.find(image => image.imageName === "odometer"));
    //     }
    //     if (inspectionConfig.selectedItems?.includes("Chassis")) {
    //         mandatoryImages.push(imagesToCapture.find(image => image.imageName === "chassis"));
    //     }
    //     if (inspectionConfig.selectedItems?.includes("Sunroof")) {
    //         mandatoryImages.push(imagesToCapture.find(image => image.imageName === "sunroof_ext"));
    //     }
    //     if (inspectionConfig.selectedItems?.includes("Sunroof")) {
    //         mandatoryImages.push(imagesToCapture.find(image => image.imageName === "sunroof_int"));
    //     }
    //     if (inspectionConfig.selectedItems?.includes("Registration number")) {
    //         mandatoryImages.push(imagesToCapture.find(image => image.imageName === "registrationNo"));
    //     }
    //     if (inspectionConfig.selectedItems?.includes("RC")) {
    //         mandatoryImages.push(imagesToCapture.find(image => image.imageName === "RC"));
    //     }
    //     if (inspectionConfig.selectedItems?.includes("Selfie with the car")) {
    //         mandatoryImages.push(imagesToCapture.find(image => image.imageName === "selfie"));
    //     }
    // } else {
    //     console.log("Config is null,setting default 20 images!");
    //     mandatoryImages = imagesToCapture.filter(image => image.id !== 10 && image.id !== 16);
    // }
    // // console.log("mandatoryImages", mandatoryImages);

    // // Sort based on the original order in imagesToCapture
    // mandatoryImages.sort((a, b) => {
    //     return imagesToCapture.findIndex(img => img.imageName === a.imageName) -
    //         imagesToCapture.findIndex(img => img.imageName === b.imageName);
    // });
    // console.log("Sorted mandatoryImages", mandatoryImages);


    const [suggestion, setSuggestion] = useState('');
    const [perfectImage, setPerfectImage] = useState(false);
    const [currentImageTitle, setCurrentImageTitle] = useState(mandatoryImages[0]);
    const [changed, setChanged] = useState("abc");

    // const uniqueKey = `${currentImageTitle.imageName}-${Date.now()}`;



    // useEffect(() => {
    //     const fetchData = async () => {
    //         // console.log("67", audit_id);
    //         try {

    //             // Fetch audit details metadata
    //             const uploadUrl = `https://caiproduction002.blob.core.windows.net/ira/insurance-inspection-details/${audit_id}.json`;
    //             const sasToken = '?sv=2020-08-04&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2050-05-06T01:59:09Z&st=2022-05-05T17:59:09Z&spr=https&sig=SsFQp5OkIrSG9gVnf4V9F4Vi463mtW25t0Vw2SQzVIM%3D';
    //             const auditDetailsMetadata = await axios.get(`${uploadUrl}${sasToken}`, { responseType: "json" });
    //             const bodyTypeRes = await axios.post("/process_data/getBodyType", {
    //                 "make": auditDetailsMetadata.data["Make"],
    //                 "model": auditDetailsMetadata.data["Model"]
    //             });
    //             console.log("76", bodyTypeRes.data);
    //             if (bodyTypeRes.data) {
    //                 setBodyType(bodyTypeRes.data["vehicle_body_type_description"]);
    //             }
    //             else {
    //                 setBodyType("---");
    //             }
    //         } catch (err) {
    //             console.log(err);
    //         }
    //     };
    //     fetchData();
    // }, []);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const blobName = `Insurance_Inspection_Details/${audit_id}.json`;

                // Step 1: Check if file exists and get signed URL from backend
                const checkResponse = await fetch('/process_data/check_document_exists_others', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ blobName })
                });

                const checkData = await checkResponse.json();

                if (checkData.exists && checkData.url) {
                    // Step 2: Fetch JSON from S3 via backend
                    const s3Response = await fetch('/process_data/get_s3_json', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ url: checkData.url })
                    });

                    const s3Data = await s3Response.json();

                    // Extract Make and Model
                    const make = s3Data?.data?.Make || '';
                    const model = s3Data?.data?.Model || '';

                    // Step 3: Call body type API
                    const bodyTypeRes = await axios.post('/process_data/getBodyType', {
                        make,
                        model
                    });

                    if (bodyTypeRes.data) {
                        setBodyType(bodyTypeRes.data['vehicle_body_type_description']);
                    } else {
                        setBodyType('---');
                    }
                } else {
                    console.warn(`File not found in S3: ${blobName}`);
                    setBodyType('---');
                }
            } catch (err) {
                console.error('Error fetching audit details:', err);
                setBodyType('---');
            }
        };

        fetchData();
    }, [audit_id]);
    const {

        setCapturedImages360,
        setCapturedImageWindshield,
        setCapturedChassisRC,
        setCapturedRegNo,
        setCapturedOdometer,
        setCapturedTyres,
        capturedInspectionImages,
        setCapturedInspectionImages,
        // setEngineVideo,
        // engineVideo,
        odometerVideo,
        setOdometerVideo
    } = useContext(FileContext);
    const { auditID, latitude, longitude } = useSelector(
        (state) => state.imagesStore
    );
    const showModal = () => {
        setIsModalVisible(true);
    };
    const handleOk = () => {
        setIsModalVisible(false);
    };
    const handleCancel = () => {
        setIsModalVisible(false);
    };
    const openCameraOption = () => {
        showModal(); // Trigger the modal when the photo is captured
        // console.log("camera options");
    };
    // console.log(isFullscreen)
    //   useEffect(()=>{
    // 	if(!isFullscreen){
    // 		requestFullscreen()
    // 	}

    //   },[isFullscreen])
    // useEffect(() => {
    //     let timer;
    //     if (videoCaptured) {
    //       timer = setTimeout(() => {
    //         navigate(`/processing/video/${audit_id}`);
    //       }, 6000);
    //     }

    //     // Cleanup function to clear the timeout if the component unmounts or videoCaptured changes
    //     return () => clearTimeout(timer);
    //   }, [videoCaptured, navigate]);
    //   const webcamRef = useRef(null);
    const mediaRecorderRef = useRef(null);
    const [capturing, setCapturing] = useState(false);
    const [recordedChunks, setRecordedChunks] = useState([]);

    const videoConstraintsForVideo = {
        facingMode: "environment",
        width: { ideal: 1920 }, // Lower resolution for mobile
        height: { ideal: 1080 },
        frameRate: { ideal: 30, max: 60 }, // Cap at 30fps for mobile
        audio: true
    };
    console.log("534", currentImageTitle);
    console.log("535", capturedInspectionImages);
    const recordedChunksRef = useRef([]);

    const handleRetakeForVideo = async () => {
        try {
            // Reset states
            setVideoCaptured(false);
            setRecordedChunks([]);
            // Reset captured images state properly
            // setCapturedInspectionImages((prevImages) => {
            // 	return prevImages.filter(image => image.id !== currentImageTitle.id); // Remove existing entry with same ID
            // });
            // Stop existing MediaRecorder if active
            if (mediaRecorderRef.current) {
                mediaRecorderRef.current.stop();
                mediaRecorderRef.current = null; // Reset the recorder reference
            }

            // Stop the previous webcam stream properly
            if (webcamRef.current?.video?.srcObject) {
                webcamRef.current.video.srcObject.getTracks().forEach(track => track.stop());
            }

            // Reinitialize webcam stream
            const stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    width: 1920,
                    height: 1080,
                    facingMode: "environment"
                },
                // audio: userId !== 'UID101' && userId !== 'USR_291628'
                audio: !!userId && userId !== 'UID101' && userId !== 'USR_291628' // Enable audio only if userId is valid and not restricted

            });

            if (webcamRef.current?.video) {
                webcamRef.current.video.srcObject = stream; // Attach new stream
            } else {
                console.error("Failed to attach stream to video element.");
                return;
            }

            console.log("Webcam stream successfully reinitialized.");

            // Wait for a moment to ensure the stream is available
            await new Promise(resolve => setTimeout(resolve, 500));

            // Prepare MediaRecorder
            const mimeType = isIOS() ? "video/mp4" : "video/webm";
            const options = {
                mimeType,
                videoBitsPerSecond: 5000000,
                audioBitsPerSecond: 256000,
            };

            mediaRecorderRef.current = new MediaRecorder(stream, options);
            mediaRecorderRef.current.addEventListener("dataavailable", handleDataAvailable);

            // Start the recording process
            mediaRecorderRef.current.start();
            console.log("Video retake process started successfully.");
        } catch (error) {
            console.error("Error during video retake process:", error);
        }
    };

    const handleDataAvailable = useCallback(({ data }) => {
        console.log("Data available:", data, data.size);
        if (data.size > 0) {

            recordedChunksRef.current.push(data); // Store in the ref
            setRecordedChunks(prev => [...prev, data]); // Update state
            // console.log("Recorded chunks updated:", recordedChunksRef.current);

            if (currentImageTitle.imageName === 'rpm_meter_video') {
                console.log("setting vdo");
                setOdometerVideo(recordedChunksRef.current)
            }
            // else if (currentImageTitle.id === 13) {
            // 	setEngineVideo(recordedChunksRef.current)
            // }
            let res = {
                file: recordedChunksRef.current,
                name: currentImageTitle.imageName,
                clickedTime: capturedTime,
                id: currentImageTitle.id,
                latitude: latitude,
                longitude: longitude,
            };
            setCapturedInspectionImages((prevImages) => {
                // Filter out any images with the same id as the new one
                const filteredImages = prevImages.filter(image => image.id !== res.id);
                console.log("560", filteredImages);

                // Add the new image
                return [...filteredImages, res];
            });
        }
    }, [currentImageTitle]);



    const handleStartCaptureClick = useCallback(() => {
        // Toggle button type state
        setBtnType(!btnType);

        // Access the video stream from the webcam reference
        const videoElement = webcamRef.current.video;
        const stream = videoElement?.srcObject;

        if (!stream || stream.getVideoTracks().length === 0) {
            console.error('No video tracks available in the stream.');
            return;
        }

        // Disable audio for userId 'UID101'
        if (!userId || userId === 'UID101' || userId === 'USR_291628') {
            const audioTracks = stream.getAudioTracks();
            audioTracks.forEach(track => track.stop()); // Stop all audio tracks
            console.log("Audio disabled for user ID: UID101");
        }

        // Start capturing the video
        setCapturing(true);

        // Reset timer and clear any existing intervals
        clearInterval(intervalRef.current);
        timerRef.current = 31;

        // Check if the mimeType is supported by the browser
        const mimeType = isIOS() ? "video/mp4" : "video/webm";
        const options = {
            mimeType: mimeType, // Fallback to webm if mp4 is not supported
            videoBitsPerSecond: 5000000, // Set a  bitrate for video (5Mbps)
            audioBitsPerSecond: 256000, // Bitrate for audio
        };
        console.log("523", userId)
        // Remove audio options for userId 'UID101'
        if (!userId || userId === 'UID101' || userId === 'USR_291628') {
            console.log("here deleting");

            delete options.audioBitsPerSecond; // Remove audio settings
        }

        try {
            console.log("start capture vdo");

            // Create MediaRecorder with the valid stream and options
            mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream, options);

            mediaRecorderRef.current.addEventListener('dataavailable', handleDataAvailable);

            // Set up the timer for recording
            intervalRef.current = setInterval(() => {
                if (timerRef.current > 0) {
                    timerRef.current -= 1;
                    setCapturing(prev => !prev); // Force re-render for timer UI
                }
            }, 1000); // Increment timer every second

            // Start the recording process
            mediaRecorderRef.current.start();

        } catch (error) {
            console.error("Error starting the MediaRecorder:", error);
        }
    }, [webcamRef, setCapturing, mediaRecorderRef, handleDataAvailable, btnType]);


    useEffect(() => {
        if (timerRef.current <= 0) {
            handleStopCaptureClick(); // Stop capture when timer hits 0
        }
    }, [capturing]);  // Listen for changes in capturing state

    const handleStopCaptureClick = useCallback(async () => {
        setBtnType(!btnType);
        setVideoCaptured(!videoCaptured);
        console.log("stop");
        mediaRecorderRef.current.stop();

        setCapturing(false);
        clearInterval(intervalRef.current);
        timerRef.current = 31;
        console.log(recordedChunks, "183")

    }, [btnType])
    // console.log("videoCaptured", videoCaptured)

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 400) {
                setDialogWidth("85vw");
            } else if (window.innerWidth <= 475) {
                setDialogWidth("74vw");
            } else if (window.innerWidth <= 550) {

            } else if (window.innerWidth <= 575) {
                setDialogText("0.6rem");
                setDialogWidth("64vw");
            } else if (window.innerWidth <= 650) {
                setDialogWidth("60vw");
            } else if (window.innerWidth <= 775) {
                setDialogWidth("57vw");
            } else if (window.innerWidth <= 875) {
                setDialogWidth("55vw");
            } else if (window.innerWidth <= 1000) {
                setDialogWidth("48vw");
            } else if (window.innerWidth <= 1100) {
                setDialogWidth("45vw");
                setDialogText("0.8rem");
            } else if (window.innerWidth <= 1300) {
                setDialogWidth("40vw");
            } else {
                setDialogWidth("35vw");
            }
        };

        handleResize();

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);


    const analyzeLighting = (imageData) => {
        //console.log(imageData, "9")
        const { data, width, height } = imageData;
        let totalBrightness = 0;

        for (let i = 0; i < data.length; i += 4) {
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            const brightness = (r + g + b) / 3;
            totalBrightness += brightness;
        }

        const averageBrightness = totalBrightness / (width * height);

        if (averageBrightness < 100) {
            return 'Increase lighting.';
        } else if (averageBrightness > 200) {
            return 'Reduce lighting.';
        } else {
            return 'Lighting looks good.';
        }
    };

    const captureAndAnalyze = useCallback(() => {
        if (webcamRef?.current && webcamRef.current?.getScreenshot()) {
            const imageSrc = webcamRef.current.getScreenshot();
            const image = new Image();
            image.src = imageSrc;

            image.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = image.width;
                canvas.height = image.height;
                ctx.drawImage(image, 0, 0, image.width, image.height);

                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const lightingSuggestion = analyzeLighting(imageData);
                if (lightingSuggestion === "Lighting looks good.") {
                    setPerfectImage(true)
                }
                else {
                    setPerfectImage(false)
                }
                setSuggestion(lightingSuggestion);
            };
        }
    }, []);

    useEffect(() => {
        if (isInLandscapeMode !== "portrait-primary" && isInLandscapeMode !== "portrait-secondary") {
            const interval = setInterval(captureAndAnalyze, 500); // Analyze every 500ms
            return () => clearInterval(interval);
        }

    }, [captureAndAnalyze, isInLandscapeMode]);


    const azure_image_file_name = (audit_id, image_name, file_name) => {
        return `${audit_id}_${image_name}_${file_name}`
    }

    // const upload_image_to_azure = async (auditID, id, clicked_time, latitude, longitude, fileName, imageBuffer, image_name) => {
    //     // console.log(imageBuffer, "296")

    //     // axios.post("/aiProcessingApis/uploadToTopic", { "id": id, "auditID": auditID, "image_name": fileName, "imageCategory": image_name, "clicked_time": clicked_time, "latitude": latitude, "longitude": longitude });

    //     const headers = {
    //         'Content-Type': 'image/jpeg',
    //         'x-ms-blob-type': 'BlockBlob'
    //     };

    //     const url = `https://caisdatahouse.blob.core.windows.net/insurance-inspection/auditImages/${fileName}?sv=2022-11-02&ss=b&srt=sco&sp=rwdlacyx&se=2030-12-24T21:24:33Z&st=2023-12-24T13:24:33Z&spr=https&sig=Ytog9LRRNwVpscHMH5q3Q8F7v6U2Te5F6oU8%2F1WArio%3D`;

    //     axios.put(url, imageBuffer, { headers })
    //         .then(response => {
    //             if (response.status === 201) {
    //                 const res = {
    //                     image_name: image_name,
    //                     status: 1,
    //                     type: "azure_img_upload_status"
    //                 }
    //                 dispatch(set_image_upload_status_retake(res))
    //             }
    //             console.log('File uploaded successfully status Code : ', response.status);
    //         })
    //         .catch(error => {
    //             console.error('Error uploading file:', error);
    //         });
    // }
    const upload_image_to_s3 = async (
        auditID,
        id,
        clicked_time,
        latitude,
        longitude,
        fileName,
        base64String, // <-- already base64
        image_name
    ) => {
        try {
            if (!base64String || base64String.length < 1000) {
                console.error('Invalid image data');
                return;
            }

            const response = await axios.post('/process_data/upload-file', {
                blobName: `Insurance_Inspection/auditImages/${fileName}`,
                fileContent: base64String, // no conversion needed
                contentType: 'image/jpeg'
            });

            if (response.status === 200) {
                dispatch(set_image_upload_status_retake({
                    image_name,
                    status: 1,
                    type: 's3_img_upload_status'
                }));
                console.log('✅ File uploaded successfully:', response.data.url);
            }
        } catch (error) {
            console.error('Error uploading image:', error.message);
        }
    };
    // const cacheImageBuffer = async (fileName, imageBuffer, clicked_time, name, type, audit_id, latitude, longitude) => {
    //     try {
    //         // Open or create the 'image-cache' cache
    //         const cache = await caches.open('image-cache');

    //         // Convert the image buffer to a Blob
    //         const imageBlob = new Blob([imageBuffer], { type: 'image/png' });

    //         // Prepare the metadata in JSON format
    //         const metadata = JSON.stringify({
    //             clicked_time,
    //             name,
    //             type,
    //             audit_id,
    //             latitude,
    //             longitude
    //         });

    //         // Create a Response object for the image
    //         const cachedImageResponse = new Response(imageBlob, {
    //             headers: { 'Content-Type': 'image/png' }
    //         });

    //         // Create a Response object for the metadata
    //         const cachedMetadataResponse = new Response(metadata, {
    //             headers: { 'Content-Type': 'application/json' }
    //         });

    //         // Cache the image with the fileName as the key
    //         await cache.put(`${fileName}`, cachedImageResponse);

    //         // Cache the metadata with a related key
    //         await cache.put(`${fileName}-metadata`, cachedMetadataResponse);

    //         console.log(`Image and metadata cached successfully with key: ${fileName}`);
    //     } catch (error) {
    //         console.error('Failed to cache image and metadata:', error);
    //     }
    // };
 function base64ToBlob(base64, contentType = 'image/png') {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }
  const cacheImageBuffer = async (
    fileName,
    base64String,
    clicked_time,
    name,
    type,
    audit_id,
    latitude,
    longitude
  ) => {
    try {
      const cache = await caches.open('image-cache');
      
      // ✅ Convert Base64 to Blob
      const imageBlob = base64ToBlob(base64String, 'image/png');

      const metadata = JSON.stringify({
        clicked_time,
        name,
        type,
        audit_id,
        latitude,
        longitude
      });

      const cachedImageResponse = new Response(imageBlob, {
        headers: { 'Content-Type': 'image/png' }
      });

      const cachedMetadataResponse = new Response(metadata, {
        headers: { 'Content-Type': 'application/json' }
      });

      await cache.put(`${fileName}`, cachedImageResponse);
      await cache.put(`${fileName}-metadata`, cachedMetadataResponse);

      console.log(`Image and metadata cached successfully with key: ${fileName}`);
    } catch (error) {
      console.error('Failed to cache image and metadata:', error);
    }
  };
    const handleFullscreenRequest = () => {
        requestFullscreen();
        setOpen(false);
    }
    const handleClose = (event) => {
        if (
            event.target.tagName.toLowerCase() !== "button" &&
            !event.target.closest("button")
        ) {
            // Prevent dialog from closing if click occurred outside of the button
            return;
        }
        setOpen(false);
    };
    const upload_video_to_azure = async (fileName, videoBlob) => {
        const videoType = videoBlob.type || 'video/mp4';

        const headers = {
            'Content-Type': videoType,
            'x-ms-blob-type': 'BlockBlob',
        };

        const url = `https://caisdatahouse.blob.core.windows.net/insurance-inspection/auditVideos/${fileName}?sv=2022-11-02&ss=b&srt=sco&sp=rwdlacyx&se=2030-12-24T21:24:33Z&st=2023-12-24T13:24:33Z&spr=https&sig=Ytog9LRRNwVpscHMH5q3Q8F7v6U2Te5F6oU8%2F1WArio%3D`;

        await axios.put(url, videoBlob, {
            headers,
            onUploadProgress: (progressEvent) => {
                const total = progressEvent.total;
                const current = progressEvent.loaded;
                const percentCompleted = Math.round((current * 100) / total);
                // setUploadProgress(percentCompleted); // Update the progress state
                console.log(`Upload progress: ${percentCompleted}%`);
            }
        })
            .then(response => {
                if (response.status === 201) {
                    console.log('Video uploaded successfully:', response.status);

                }
            })
            .catch(error => {
                console.error('Error uploading video:', error);
            });
    };
    const upload_images_data_db = async (formData, image_name, maxRetries = 3) => {
        let attempt = 0;
        console.log("fd", formData);

        const tryUpload = () => {

            axiosInstance.post(
                "/process_data/upload_process_store_individually_retake",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            )
                .then(response => {
                    if (response.status === 200) {

                        const res = {
                            image_name: image_name,
                            status: 1,
                            type: "sql_upload_status"
                        }
                        console.log("794", image_name, res);

                        dispatch(set_image_upload_status_retake(res))

                    }
                    console.log("Successful", response.data);
                })
                .catch(error => {
                    attempt++;
                    if (attempt < maxRetries && (error.code === 'ECONNABORTED' || (error.response && error.response.status >= 500))) {
                        console.log(`Attempt ${attempt} failed. Retrying in ${Math.pow(2, attempt)} seconds...`);
                        // setTimeout(tryUpload, Math.pow(2, attempt) * 1000);
                    } else {
                        console.error("Max retries reached or non-retryable error:", error);
                    }
                });
        };
        tryUpload();
    };
    const handleSave = () => {
        // setImageCaptured(false);
        // setShowCamera(false);
        // console.log(imageBuffer, image, "381")
        if (!auditID) {
            let alert = {
                snackbarOpen: true,
                snackbarMessage: "Audit not found !",
                snackbarMessageSeverity: "error",
            };
            dispatch(
                setAlertMessageSnackbarMessageSeverity(alert.snackbarMessageSeverity)
            );
            dispatch(setAlertMessageSnackbarMsg(alert.snackbarMessage));
            dispatch(setAlertMessageSnackbarOpen(alert.snackbarOpen));
            setTimeout(() => {
                dispatch(setAlertMessageSnackbarOpen(false));
            }, 5000);

            navigate("/");
        } else {
            console.log("currentImageIndex-642", currentImageIndex);

            const currentImage = mandatoryImages[currentImageIndex];
            // const cur_img_id = currentImage.id >= 14 ? currentImage.id - 2 : currentImage.id;
            console.log("currentImage", currentImage);

            let res = {
                file: image,
                name: currentImage.imageName,
                clickedTime: capturedTime,
                id: currentImage.id,
                latitude: latitude,
                longitude: longitude,
            };
            let activeId;

            if (
                currentImage.imageName === "inner_windshield" ||
                currentImage.imageName === "outer_windshield"
            ) {
                setCapturedImageWindshield((prevImages) => [...prevImages, res]);
                activeId = "1";
            } else if (currentImage.imageName === "registrationNo") {
                setCapturedRegNo((prevImages) => [...prevImages, res]);
                activeId = "1";
            } else if (
                currentImage.imageName === "chassis" ||
                currentImage.imageName === "RC"
            ) {
                setCapturedChassisRC((prevImages) => [...prevImages, res]);
                activeId = "1";
            } else if (currentImage.imageName === "odometer") {
                setCapturedOdometer((prevImages) => [...prevImages, res]);
                activeId = "1";
            } else if (currentImage.imageName === "front_left_tyre" || currentImage.imageName === "back_left_tyre" || currentImage.imageName === "back_right_tyre" || currentImage.imageName === "front_right_tyre") {
                setCapturedTyres((prevImages) => [...prevImages, res]);
                activeId = "1";
            }
            else {
                setCapturedImages360((prevImages) => [...prevImages, res]);
                activeId = "0";
            }
            setCapturedInspectionImages((prevImages) => {
                // Filter out any images with the same id as the new one
                const filteredImages = prevImages.filter(image => image.id !== res.id);

                // Add the new image
                return [...filteredImages, res];
            });

            // console.log(azure_image_file_name(auditID, res.name, res.file.name), "355")
            try {
                const fileName = azure_image_file_name(auditID, res.name, res.file.name);

                // console.log(res.file, "378")
                const reader = new FileReader();
                let buffer_curr;
                reader.onloadend = () => {
                    // buffer_curr = reader.result;
                    const dataUrl = reader.result; // e.g., "data:image/jpeg;base64,/9j/..."
                    const base64String = dataUrl.split(',')[1]; // Remove prefix


                    // setImageBuffer(buffer_curr)
                    // console.log(buffer_curr, "457"); // You can now use the buffer
                    cacheImageBuffer(fileName, base64String, res.clickedTime, res.name, res.id, auditID, latitude, longitude)
                    // upload_image_to_azure(auditID, res.id, res.clickedTime, latitude, longitude, fileName, buffer_curr, res.name);
                    upload_image_to_s3(
                        auditID,
                        res.id,
                        res.clickedTime,
                        latitude,
                        longitude,
                        fileName,
                        base64String,
                        res.name
                    )
                    if (auditID) {
                        const formData = new FormData();
                        // formData.append("file", res.file);

                        formData.append("clickedTime", res.clickedTime);
                        formData.append("name", res.name);
                        formData.append("id", res.id > 18 && res.id <= 22 ? res.id - 1 : res.id);
                        formData.append("auditID", auditID);
                        // formData.append("data", capturedImages360);
                        formData.append("latitude", latitude);
                        formData.append("longitude", longitude);
                        formData.append("azure_image_name", azure_image_file_name(auditID, res.name, res.file.name));
                        upload_images_data_db(formData, res.name);

                    }
                };
                // reader.readAsArrayBuffer(image);
                reader.readAsDataURL(image);

            } catch (err) {
                console.log(err);
            }
        }
    };
    // const upload_vdo_data_db = async (formData, image_name, maxRetries = 3) => {
    // 	let attempt = 0;
    // 	// console.log("fd",formData);

    // 	const tryUpload = () => {

    // 		axiosInstance.post(
    // 			"/process_data/upload_video_detail",
    // 			formData,
    // 			{
    // 				headers: {
    // 					"Content-Type": "multipart/form-data",
    // 				},
    // 			}
    // 		)
    // 			.then(response => {
    // 				if (response.status === 200) {

    // 					const res = {
    // 						image_name: image_name,
    // 						status: 1,
    // 						type: "sql_upload_status"
    // 					}
    // 					dispatch(set_image_upload_status_retake(res))

    // 				}
    // 				console.log("Successful", response.data);
    // 			})
    // 			.catch(error => {
    // 				attempt++;
    // 				if (attempt < maxRetries && (error.code === 'ECONNABORTED' || (error.response && error.response.status >= 500))) {
    // 					console.log(`Attempt ${attempt} failed. Retrying in ${Math.pow(2, attempt)} seconds...`);
    // 					// setTimeout(tryUpload, Math.pow(2, attempt) * 1000);
    // 				} else {
    // 					console.error("Max retries reached or non-retryable error:", error);
    // 				}
    // 			});
    // 	};
    // 	tryUpload();
    // };
    // const handleSaveVideoDetails = () => {
    // 	// setImageCaptured(false);
    // 	// setShowCamera(false);
    // 	// console.log(imageBuffer, image, "381")
    // 	if (!auditID) {
    // 		let alert = {
    // 			snackbarOpen: true,
    // 			snackbarMessage: "Audit not found !",
    // 			snackbarMessageSeverity: "error",
    // 		};
    // 		dispatch(
    // 			setAlertMessageSnackbarMessageSeverity(alert.snackbarMessageSeverity)
    // 		);
    // 		dispatch(setAlertMessageSnackbarMsg(alert.snackbarMessage));
    // 		dispatch(setAlertMessageSnackbarOpen(alert.snackbarOpen));
    // 		setTimeout(() => {
    // 			dispatch(setAlertMessageSnackbarOpen(false));
    // 		}, 5000);

    // 		navigate("/");
    // 	} else {
    // 		console.log("currentImageIndex-642", currentImageIndex);
    // 		const currentImage = mandatoryImages[currentImageIndex];
    // 		// const cur_img_id = currentImage.id >= 14 ? currentImage.id - 2 : currentImage.id;
    // 		console.log("currentImage", currentImage);

    // 		let res = {
    // 			file: image,
    // 			name: currentImage.imageName,
    // 			clickedTime: capturedTime,
    // 			id: currentImage.id,
    // 			latitude: latitude,
    // 			longitude: longitude,
    // 		};
    // 		console.log("1144",res);

    // 		// console.log(azure_image_file_name(auditID, res.name, res.file.name), "355")
    // 		try {
    // 			// const fileName = azure_image_file_name(auditID, res.name, res.file.name);

    // 			// console.log(res.file, "378")
    // 			const reader = new FileReader();
    // 			let buffer_curr;
    // 			reader.onloadend = () => {
    // 				// buffer_curr = reader.result;
    // 				// // setImageBuffer(buffer_curr)
    // 				// // console.log(buffer_curr, "457"); // You can now use the buffer
    // 				// cacheImageBuffer(fileName, buffer_curr, res.clickedTime, res.name, res.id, auditID, latitude, longitude)

    // 				if (auditID) {
    // 					const formData = new FormData();
    // 					// formData.append("file", res.file);

    // 					formData.append("clickedTime", res.clickedTime);
    // 					formData.append("name", res.name);
    // 					formData.append("id", res.id > 18 && res.id <= 22 ? res.id - 1 : res.id);
    // 					formData.append("auditID", auditID);
    // 					// formData.append("data", capturedImages360);
    // 					formData.append("latitude", latitude);
    // 					formData.append("longitude", longitude);
    // 					formData.append("azure_image_name", azure_image_file_name(auditID, res.name, res.file.name));
    // 					upload_vdo_data_db(formData, res.name);

    // 				}
    // 			};
    // 			reader.readAsArrayBuffer(image);

    // 		} catch (err) {
    // 			console.log(err);
    // 		}
    // 	}
    // };
    const upload_vdo_data_db = async (formData, image_name, maxRetries = 3) => {
        let attempt = 0;
        console.log("1224", formData);

        // const tryUpload = () => {
        // 	axios.post(
        // 		"/process_data/upload_video_detail",
        // 		formData,
        // 		{
        // 			headers: {
        // 				"Content-Type": "multipart/form-data",
        // 			},
        // 		}
        // 	)
        // 		.then(response => {
        // 			if (response.status === 200) {
        // 				const res = {
        // 					image_name: image_name,
        // 					status: 1,
        // 					type: "sql_upload_status"
        // 				};
        // 				dispatch(set_image_upload_status_retake(res));
        // 			}
        // 			console.log("Successful", response.data);
        // 		})
        // 		.catch(error => {
        // 			attempt++;
        // 			if (attempt < maxRetries && (error.code === 'ECONNABORTED' || (error.response && error.response.status >= 500))) {
        // 				console.log(`Attempt ${attempt} failed. Retrying in ${Math.pow(2, attempt)} seconds...`);
        // 				// Retry logic (optional)
        // 			} else {
        // 				console.error("Max retries reached or non-retryable error:", error);
        // 			}
        // 		});
        // };
        const tryUpload = async () => {
            try {
                console.log("1259");

                const response = await axios.post("/process_data/upload_video_detail", formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
                console.log("1262", response.data);

                if (response.status === 200) {
                    dispatch(set_image_upload_status_retake({
                        image_name,
                        status: 1,
                        type: "sql_upload_status"
                    }));
                    console.log("Successful vdo data", response.data);
                }
            } catch (error) {
                attempt++;
                if (attempt < maxRetries && (error.code === 'ECONNABORTED' || (error.response && error.response.status >= 500))) {
                    console.log(`Attempt ${attempt} failed. Retrying in ${Math.pow(2, attempt)} seconds...`);
                } else {
                    console.error("Max retries reached or non-retryable error:", error);
                }
            }
        };

        tryUpload();
    };

    const handleSaveVideoDetails = () => {
        if (!auditID) {
            let alert = {
                snackbarOpen: true,
                snackbarMessage: "Audit not found !",
                snackbarMessageSeverity: "error",
            };
            dispatch(setAlertMessageSnackbarMessageSeverity(alert.snackbarMessageSeverity));
            dispatch(setAlertMessageSnackbarMsg(alert.snackbarMessage));
            dispatch(setAlertMessageSnackbarOpen(alert.snackbarOpen));
            setTimeout(() => {
                dispatch(setAlertMessageSnackbarOpen(false));
            }, 5000);

            navigate("/");
        } else {
            console.log("currentImageIndex-642", currentImageIndex);
            const currentImage = mandatoryImages[currentImageIndex];
            const formattedCaptureTime = moment().format("YYYY-MM-DD HH:mm:ss");
            console.log("vdo time", formattedCaptureTime);

            // const cur_img_id = currentImage.id >= 14 ? currentImage.id - 2 : currentImage.id;
            console.log("currentImage", currentImage);
            let res = {
                file: image,
                name: currentImage.imageName,
                clickedTime: formattedCaptureTime,
                id: currentImage.id,
                latitude: latitude,
                longitude: longitude,
            };
            console.log("1144", res);
            const formData = new FormData();
            formData.append("auditID", auditID);
            formData.append("clickedTime", res.clickedTime);

            upload_vdo_data_db(formData, "video_detail");
        }
    };

    useEffect(() => {
        if ((imageCaptured || videoCaptured) && !hasRetaken) {
            if (imageCaptured) {
                handleSave();  // Call handleSave immediately when imageCaptured is true
            }
            // if(videoCaptured){
            // 	if(currentImageTitle.id === 12){
            // 	const fileName = `${auditID}_odometer_video.mp4`;
            // 	upload_video_to_azure(fileName,odometerVideo[0])
            //    }
            //    else if(currentImageTitle.id === 13){
            // 	const fileName = `${auditID}_engine_video.mp4`;
            // 	 setEngineVideo(fileName,engineVideo[0])
            //    }
            // }

            const timer = setTimeout(() => {
                const currentImage = imagesToCapture[currentImageIndex];
                // console.log(currentImageIndex < imagesToCapture.length - 1);
                // console.log(currentImageIndex, imagesToCapture.length - 1);
                if (currentImageIndex < mandatoryImages.length - 1) {
                    setCurrentImageIndex(currentImageIndex + 1);
                    setCurrentImageTitle(mandatoryImages[currentImageIndex + 1]);
                    console.log(mandatoryImages[currentImageIndex + 1].viewName, "371")
                    if (mandatoryImages[currentImageIndex + 1].viewName === "Selfie") {

                        videoConstraintsRef.current = {
                            facingMode: "user", // switch to front camera
                            width: 1920,
                            height: 1080,
                        };
                    }
                    // setShowCamera(true);
                }
                setImageCaptured(false);  // Update states after 6 seconds

                if (videoCaptured) {
                    handleSaveVideoDetails();
                    setVideoCaptured(false);
                }
                if (currentImageIndex < mandatoryImages.length - 1) {
                    setShowInstructionPage(
                        mandatoryImages[currentImageIndex + 1].viewName === "RPM Meter Video"
                    );
                }
                setShowCamera(true);
                // console.log("Updated states after 6 seconds");
            }, 6000);

            return () => clearTimeout(timer);  // Clean up the timer
        }
    }, [hasRetaken, imageCaptured, videoCaptured]);


    useEffect(() => {
        const handleBeforeUnload = (event) => {
            const message = "Are you sure you want to leave?";
            event.returnValue = message;
            return message;
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);


    useEffect(() => {
        if (!auditID) {
            console.log("audit not present");
            navigate("/");
        }
    }, [auditID]);

    useEffect(() => {
        console.log("1223", capturedInspectionImages.length, mandatoryImages.length);

        if (capturedInspectionImages.length === mandatoryImages.length) {
            console.log("here for navigation");

            const timer = setTimeout(() => {
                navigate(`/processingretake/${auditID}`);
            }, 6000); // Pass 6000 directly

            return () => {
                clearTimeout(timer); // Clear timeout on cleanup
            };
        }
    }, [capturedInspectionImages, auditID, navigate]); // Add auditID and navigate as dependencies

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            const message = "Are you sure you want to leave?";
            event.returnValue = message;
            return message;
        };

        const handlePopState = (event) => {
            // console.log("back button");
            if (window.confirm("Are you sure you want to navigate away?")) {
                navigate("/");
            }
        };

        const handleHashChange = (event) => {
            if (window.confirm("Are you sure you want to navigate away?")) {
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);
        window.addEventListener("popstate", handlePopState);
        window.addEventListener("hashchange", handleHashChange);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
            window.removeEventListener("popstate", handlePopState);
            window.removeEventListener("hashchange", handleHashChange);
        };
    }, []);

    const [windowDimensions, setWindowDimensions] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    const setDimensions = () => {
        const img = new Image();
        img.src = currentImageTitle?.imageStencils;
        img.onload = () => {
            const containerWidth = window.innerWidth;
            const containerHeight = window.innerHeight;
            const containerAspectRatio = containerWidth / containerHeight;
            const imgAspectRatio = img.width / img.height;

            let width, height;

            if (imgAspectRatio > containerAspectRatio) {
                width = containerWidth;
                height = containerWidth / imgAspectRatio;
            } else {
                width = containerHeight * imgAspectRatio;
                height = containerHeight;
            }

            setImageDimensions({ width, height });
        };
    };

    useEffect(() => {
        setDimensions();
        window.addEventListener("resize", setDimensions);
        return () => {
            window.removeEventListener("resize", setDimensions);
        };
    }, [currentImageTitle?.imageStencils]);

    useEffect(() => {
        const handleResize = () => {
            setWindowDimensions({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    console.log("955", capturedInspectionImages.length)
    const handleRetakeClick = () => {
        console.log("clicked retake");

        // Set retake flag
        setHasRetaken(true);

        // Trigger recapture logic
        handleRecapture();

        // Remove the last saved image
        setCapturedInspectionImages((prevImages) => {
            if (prevImages.length === 0) return []; // Handle edge case when the array is empty
            return prevImages.slice(0, -1); // Remove the last image
        });
    };
    const handleFinishRetakeImages = () => {
        navigate(`/processingretake/${auditID}`)
    }

    const handleRecapture = () => {
        setShowCamera(true);
        setImageCaptured(false);
        setHasRetaken(false)
    };

    const getDeviceType = () => {
        const os = window.platform.os;

        if (os.family === "iOS") {
            return "iPhone";
        } else if (os.family === "Android") {
            return "Android";
        } else {
            const isLaptop = window.innerWidth > 1024;
            return isLaptop ? "Laptop" : "Unknown Device";
        }
    };
    const deviceType = getDeviceType();
    let mutipier = 8;
    if (deviceType === "Android") {
        mutipier = 1;
    }

    const videoConstraintsRef = useRef({
        width: 1920,
        height: 1080,
        deviceId: "cb3ef82dfb1222616061f0cc45c124568bf42041c22245e71a89f6377208fc38",
        facingMode: "environment"

    });

    // console.log(videoConstraintsRef.current.facingMode, "video constraints")

    useEffect(() => {
        async function fetchDevices() {
            const devices = await navigator.mediaDevices.enumerateDevices();
            const videoDevices = devices.filter(
                (i) =>
                    i.kind === "videoinput" &&
                    (i.label.includes("back") || i.label.includes("rear"))
            );
            setDevices(videoDevices);
            if (videoDevices.length > 0) {
                if (videoDevices.length === 2) {
                    setActiveDeviceId(videoDevices[1].deviceId);
                } else setActiveDeviceId(videoDevices[0].deviceId);
            }
        }

        fetchDevices();
    }, []);

    const handleCameraError = () => {
        let alert = {
            snackbarOpen: true,
            snackbarMessage: "camera permission not granted !",
            snackbarMessageSeverity: "error",
        };
        dispatch(
            setAlertMessageSnackbarMessageSeverity(alert.snackbarMessageSeverity)
        );
        dispatch(setAlertMessageSnackbarMsg(alert.snackbarMessage));
        dispatch(setAlertMessageSnackbarOpen(alert.snackbarOpen));
        setTimeout(() => {
            dispatch(setAlertMessageSnackbarOpen(false));
        }, 5000);
    };
    const axiosInstance = axios.create({
        timeout: 30000,
    });


    const buttonStyle = {
        display: "flex",
        cursor: "pointer",
        alignItems: "center",
        justifyContent: "center",
        width: "72px",
        height: "72px",
        backgroundColor: "transparent",
        borderRadius: "50%",
        border: perfectImage ? "4px solid #4CAF50" : "4px solid white",
        padding: "1px", // gap
    };

    const innerCircleStyle = {
        width: "55px",
        height: "55px",
        backgroundColor: "white",
        borderRadius: "50%",
    };


    const capturePhoto = React.useCallback(() => {
        const imageSrc = webcamRef.current.getScreenshot({
            width: videoConstraintsRef.current.width,
            height: videoConstraintsRef.current.height,
            quality: 1,
        });
        const formattedCaptureTime = moment().format("YYYY-MM-DD HH:mm:ss");

        const dataURLtoBlob = (dataURL) => {
            const byteString = atob(dataURL.split(',')[1]);
            const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ab], { type: mimeString });
        };

        const blob = dataURLtoBlob(imageSrc);
        // console.log(imageSrc, "imageSrc")
        const file = new File([blob], "captured_image.jpeg", {
            type: "image/jpeg",
        });

        setImage(file);
        setCapturedTime(formattedCaptureTime);
        console.log("1634", file, capturedTime);

        // Convert the file to an ArrayBuffer (Buffer)
        const reader = new FileReader();
        reader.onloadend = () => {
            const buffer = reader.result;
            setImageBuffer(buffer)
            // console.log(buffer); // You can now use the buffer
            // Do something with the buffer if needed
        };
        reader.readAsArrayBuffer(file);
        setImageCaptured(true);
    }, [webcamRef]);

    useEffect(() => {
        const updateOrientation = () => {
            setIsInLandscapeMode(window.screen.orientation.type);
        };
        window.addEventListener("orientationchange", updateOrientation);

        return () => {
            window.removeEventListener("orientationchange", updateOrientation);
        };
    }, [isInLandscapeMode]);



    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes < 10 ? '0' : ''}${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    };

    useEffect(() => {
        const checkPermissions = () => {
            navigator.permissions
                .query({ name: "camera" })
                .then((permissionStatus) => {
                    if (permissionStatus.state === "granted") {
                    } else if (permissionStatus.state === "prompt") {
                        // Prompt the user for camera permission
                        navigator.mediaDevices
                            .getUserMedia({ video: true })
                            .then(() => {
                                console.log("Prompting for camera permissions");
                            })
                            .catch((error) => {
                                console.log("Error:", error);
                            });
                    } else {
                    }
                })
                .catch((error) => console.log("Error:", error));
        };
        checkPermissions();
    }, []);
    // console.log(currentImageTitle.viewName, "457");


    // const [zoomLevel, setZoomLevel] = useState("!");
    // useEffect(() => {
    // 	const checkZoomLevel = async () => {
    // 		try {
    // 			// Get the video track from the webcam
    // 			const stream = webcamRef.current?.video.srcObject;
    // 			if (stream) {
    // 				const track = stream.getVideoTracks()[0];
    // 				const capabilities = track.getCapabilities(); // To see if zoom is supported
    // 				const settings = track.getSettings(); // Get current settings

    // 				// Check if zoom is supported by the device
    // 				if (capabilities.zoom) {
    // 					setZoomLevel(settings.zoom || "Default zoom");
    // 				} else {
    // 					setZoomLevel("Zoom not supported on this device");
    // 				}
    // 			}
    // 		} catch (error) {
    // 			console.error("Error fetching zoom level: ", error);
    // 		}
    // 	};

    // 	// Call the function when the webcam stream is ready
    // 	if (webcamRef.current) {
    // 		webcamRef.current.video.addEventListener("loadedmetadata", checkZoomLevel);
    // 	}

    // 	return () => {
    // 		if (webcamRef.current) {
    // 			webcamRef.current.video.removeEventListener("loadedmetadata", checkZoomLevel);
    // 		}
    // 	};
    // }, [webcamRef]);

    const [zoomLevel, setZoomLevel] = useState(1);
    useEffect(() => {
        const applyZoom = async () => {
            try {
                const stream = webcamRef.current?.video?.srcObject;
                if (stream) {
                    const track = stream.getVideoTracks()[0];
                    const capabilities = track.getCapabilities();
                    if (capabilities.zoom) {
                        const settings = track.getSettings();
                        setZoomLevel(settings.zoom || 1);
                        await track.applyConstraints({
                            advanced: [{ zoom: 1.08 }],
                        });
                        setZoomLevel(1.00);
                    } else {
                        console.log("Zoom is not supported on this device.");
                    }
                }
            } catch (error) {
                console.error("Error applying zoom level: ", error);
            }
        };

        if (webcamRef.current) {
            webcamRef.current.video.addEventListener("loadedmetadata", applyZoom);
        }

        return () => {
            if (webcamRef.current) {
                webcamRef.current.video.removeEventListener("loadedmetadata", applyZoom);
            }
        };
    }, [webcamRef]);

    //audio rec
    const [audioChunks, setAudioChunks] = useState([]);
    const [mediaRecorder, setMediaRecorder] = useState(null);
    const [isRecording, setIsRecording] = useState(false);

    // const upload_audio_to_azure = async (auditID, audioBlob) => {
    //     const audioType = audioBlob.type || 'audio/webm';

    //     const headers = {
    //         'Content-Type': audioType,
    //         'x-ms-blob-type': 'BlockBlob',
    //     };

    //     const fileName = `${auditID}_audio.webm`; // Adjust the file extension if necessary

    //     const url = `https://caisdatahouse.blob.core.windows.net/insurance-inspection/auditAudios/${fileName}?sv=2022-11-02&ss=b&srt=sco&sp=rwdlacyx&se=2030-12-24T21:24:33Z&st=2023-12-24T13:24:33Z&spr=https&sig=Ytog9LRRNwVpscHMH5q3Q8F7v6U2Te5F6oU8%2F1WArio%3D`;

    //     await axios.put(url, audioBlob, {
    //         headers,
    //         onUploadProgress: (progressEvent) => {
    //             const total = progressEvent.total;
    //             const current = progressEvent.loaded;
    //             const percentCompleted = Math.round((current * 100) / total);
    //             console.log(`Upload progress: ${percentCompleted}%`);
    //         },
    //     })
    //         .then(response => {
    //             if (response.status === 201) {
    //                 console.log('Audio uploaded successfully:', response.status);
    //             }
    //         })
    //         .catch(error => {
    //             console.error('Error uploading audio:', error);
    //         });
    // };

    // const stopAudioRecordingAndUpload = async (auditID, currentImageIndex, imagesToCapture, recorder) => {
    //     if (recorder && recorder.state !== 'inactive') {
    //         console.log("Stopping the audio recording...");

    //         recorder.ondataavailable = async (event) => {
    //             const audioBlob = event.data;
    //             console.log("Audio data available.");

    //             // Upload the audio to Azure
    //             await upload_audio_to_azure(auditID, audioBlob);
    //             console.log("Audio uploaded to Azure.");
    //         };

    //         recorder.stop(); // Stop the recording

    //     }
    // };
const stopAudioRecordingAndUpload = async (
  auditID,
  currentImageIndex,
  imagesToCapture,
  recorder
) => {
  if (recorder && recorder.state !== 'inactive') {
    console.log('Stopping the audio recording...')

    recorder.ondataavailable = async event => {
      const audioBlob = event.data;
      console.log('Audio data available.');

      // Convert audioBlob to Base64
      const base64Audio = await blobToBase64(audioBlob);

      // Prepare payload
      const payload = {
        blobName: `Insurance_Inspection/auditAudios/${auditID}_audio.webm`, // keep naming convention
        fileContent: base64Audio,
        contentType: audioBlob.type || 'audio/webm'
      };

      // Send to backend
      try {
        const response = await fetch('/process_data/upload-file', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });

        const result = await response.json();
        if (response.ok) {
          console.log('Audio uploaded successfully:', result.url);
        } else {
          console.error('Upload failed:', result.error);
        }
      } catch (error) {
        console.error('Error uploading audio:', error);
      }
    };

    recorder.stop(); // Stop the recording
  }
};

// Helper function to convert Blob to Base64
const blobToBase64 = blob => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64data = reader.result.split(',')[1]; // remove data:... prefix
      resolve(base64data);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};
    useEffect(() => {

        const startAudioRecording = async () => {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                const recorder = new MediaRecorder(stream);

                recorder.ondataavailable = (event) => {
                    if (event.data.size > 0) {
                        setAudioChunks((prev) => [...prev, event.data]);
                    }
                };

                setMediaRecorder(recorder); // Set recorder instance
                recorder.start(); // Automatically start recording
                setIsRecording(true);

                console.log("Audio recording started.");
            } catch (error) {
                console.error("Error accessing audio stream: ", error);
            }
        };

        console.log("1620", userId);

        // Conditionally start recording if userId is not 'UID101'
        if (userId && userId !== 'UID101' && userId !== 'USR_291628') {
            console.log("1624", userId);

            startAudioRecording();
        }

        return () => {
            if (mediaRecorder && mediaRecorder.state !== "inactive") {
                mediaRecorder.stop();
                setIsRecording(false);
            }
        };
    }, []);


    useEffect(() => {
        console.log("vn", mandatoryImages[currentImageIndex].viewName);

        if (mandatoryImages[currentImageIndex]?.viewName === "RPM Meter Video") {
            console.log("1529 here!");
            stopAudioRecordingAndUpload(audit_id, currentImageIndex, mandatoryImages, mediaRecorder);
        }
    }, [isRecording, imagesToCapture, currentImageIndex, mediaRecorder]);

    const imagePaths = {
        front_side: `${process.env.PUBLIC_URL}/inspection-car-360/car-front-side.svg`,
        front_left_side: `${process.env.PUBLIC_URL}/inspection-car-360/car-front-left-side.svg`,
        left_side: `${process.env.PUBLIC_URL}/inspection-car-360/car-left-side.svg`,
        back_left_side: `${process.env.PUBLIC_URL}/inspection-car-360/car-back-left-side.svg`,
        back_side: `${process.env.PUBLIC_URL}/inspection-car-360/car-back-side.svg`,
        back_right_side: `${process.env.PUBLIC_URL}/inspection-car-360/car-back-right-side.svg`,
        right_side: `${process.env.PUBLIC_URL}/inspection-car-360/car-right-side.svg`,
        front_right_side: `${process.env.PUBLIC_URL}/inspection-car-360/car-front-right-side.svg`,
        outer_windshield: `${process.env.PUBLIC_URL}/inspection-car-other-parts/outer-windshield.svg`,
        inner_windshield: `${process.env.PUBLIC_URL}/inspection-car-other-parts/inner-windshield.svg`,
        odometer: `${process.env.PUBLIC_URL}/inspection-car-other-parts/odometer.svg`,
        rpm_meter_video: `${process.env.PUBLIC_URL}/inspection-car-other-parts/video.png`,
        engine_video: `${process.env.PUBLIC_URL}/inspection-car-other-parts/video.png`,
        registrationNo: `${process.env.PUBLIC_URL}/inspection-car-other-parts/registration-no.svg`,
        chassis: `${process.env.PUBLIC_URL}/inspection-car-other-parts/chassis-no.svg`,
        RC: `${process.env.PUBLIC_URL}/inspection-car-other-parts/rc.svg`,

        front_left_tyre: `${process.env.PUBLIC_URL}/inspection-car-other-parts/front-left-tyre.svg`,
        front_right_tyre: `${process.env.PUBLIC_URL}/inspection-car-other-parts/back-right-tyre.svg`,
        back_right_tyre: `${process.env.PUBLIC_URL}/inspection-car-other-parts/front-right-tyre.svg`,
        back_left_tyre: `${process.env.PUBLIC_URL}/inspection-car-other-parts/back-left-tyre.svg`,
        selfie: `${process.env.PUBLIC_URL}/inspection-car-other-parts/selfie.svg`,

        sunroof_ext: `${process.env.PUBLIC_URL}/inspection-car-other-parts/Sunroof-Ext-Icon.svg`,
        sunroof_int: `${process.env.PUBLIC_URL}/inspection-car-other-parts/Sunroof-Int-Icon.svg`,
    };
    const [isIconVisible, setIsIconVisible] = useState(true);


    useEffect(() => {
        // Reset the icon visibility whenever `currentImageTitle` changes
        setIsIconVisible(true);

        // Set a timer to hide the icon after 5 seconds
        const timer = setTimeout(() => {
            setIsIconVisible(false); // Hide the icon
        }, 8000);

        // Cleanup timer when the component unmounts or `currentImageTitle` changes
        return () => clearTimeout(timer);
    }, [currentImageTitle]);
    console.log("Rendering, isIconVisible:", isIconVisible);
    const [isNetworkPoor, setIsNetworkPoor] = useState(false);

    // useEffect(() => {
    // 	console.log("img-id", imagesToCapture[currentImageIndex]?.id);

    // 	const testSpeed = async () => {
    // 		const fileSize = 5 * 1024 * 1024; // 5MB file
    // 		const testFile = 'https://speed.cloudflare.com/__down?bytes=5000000'; // Cloudflare test file
    // 		const startTime = new Date().getTime();

    // 		try {
    // 			const response = await fetch(testFile);
    // 			await response.arrayBuffer();
    // 			const endTime = new Date().getTime();

    // 			const durationInSeconds = (endTime - startTime) / 1000;
    // 			const speedMbps = (fileSize / durationInSeconds / (1024 * 1024) * 8).toFixed(2);
    // 			console.log("Network Speed:", speedMbps, "Mbps");

    // 			if (speedMbps < 5) { // If speed is below 5 Mbps, show toast
    // 				setIsNetworkPoor(true);
    // 				toast.warn("Network is poor", {
    // 					position: "bottom-right",
    // 					autoClose: 3000,
    // 					hideProgressBar: false,
    // 					closeOnClick: true,
    // 					pauseOnHover: false,
    // 					draggable: false,
    // 					theme: "colored",
    // 					style: {
    // 						backgroundColor: "#FFB6C1", // Light Pink
    // 						color: "#000", // Black text for better readability
    // 						width: "auto",
    // 						maxWidth: "250px",
    // 						padding: "10px 15px",
    // 					},
    // 				});
    // 			} else {
    // 				setIsNetworkPoor(false);
    // 			}
    // 		} catch (error) {
    // 			console.error("Speed test failed:", error);
    // 			setIsNetworkPoor(true);
    // 			toast.error("Network error", {
    // 				position: "bottom-right",
    // 				autoClose: 3000,
    // 				style: { backgroundColor: "#FFB6C1", color: "#000" },
    // 			});
    // 		}
    // 	};

    // 	const checkNetwork = () => {
    // 		const imageId = imagesToCapture[currentImageIndex]?.id;
    // 		console.log("img-id-inside", imageId);

    // 		// Run speed test only when image ID is between 14 and 17
    // 		if (imageId >= 14 && imageId <= 17) {
    // 			console.log("Checking network speed...");
    // 			testSpeed();
    // 		}
    // 	};

    // 	const interval = setInterval(checkNetwork, 30000); // Check every 30 seconds

    // 	return () => clearInterval(interval);
    // }, [currentImageIndex, imagesToCapture]); // Added dependencies to track changes


    useEffect(() => {
        console.log("img-id", imagesToCapture[currentImageIndex].id);

        const checkNetwork = () => {
            console.log("img-id-inside", imagesToCapture[currentImageIndex].id);

            if (
                imagesToCapture[currentImageIndex]?.id >= 15 &&
                imagesToCapture[currentImageIndex]?.id < 18
            ) {
                console.log("checking net..");

                if (navigator.connection) {
                    const { downlink, effectiveType } = navigator.connection;
                    console.log("1571", downlink, effectiveType);

                    if (downlink < 5 || effectiveType === "3g" || effectiveType === "2g") {
                        setIsNetworkPoor(true);
                        toast.warn("Network is poor", {
                            position: "bottom-right", // Set toast position
                            autoClose: 3000, // Close after 3 seconds
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: false,
                            theme: "colored",
                            style: {
                                backgroundColor: "#FC350B",
                                color: "#fffff",
                                width: "auto",
                                maxWidth: "300px", // Set a max limit
                                padding: "10px 20px" // Improve spacing ,
                            }
                        });
                    } else {
                        setIsNetworkPoor(false);
                    }
                }
            }
        };

        const interval = setInterval(checkNetwork, 30000); // Check every 30 seconds
        return () => clearInterval(interval);
    }, []);
    return (
        <div ref={cameraContainerRef}>
            <Dialog
                open={open}
                onClose={handleClose}
                className="full_screen_class"
                PaperProps={{
                    style: {
                        width: dialogWidth,
                        padding: "0.5rem 0.5rem",
                        paddingBottom: "0.5rem",
                        borderRadius: "4px",
                        // position:"absolute",
                        // top:"0",
                        margin: "0",
                    },
                }}
            >
                <DialogContent sx={{ padding: "0.2rem 0.3rem" }}>
                    <DialogTitle
                        style={{
                            fontSize: dialogText,
                            // textAlign: "center",
                            color: "black",
                            padding: "0.4rem 0",
                            fontWeight: "600",
                        }}
                    >
                        Full Screen Mode ?
                    </DialogTitle>
                    <DialogContentText sx={{ color: "black", fontSize: "0.8rem" }}>
                        Switch to full screen mode.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ padding: "0.4rem" }}>
                    <div
                        style={{
                            // border: "1px solid #367588",
                            // borderRadius: "30px",
                            padding: "0.1rem",
                        }}
                    >
                        <button
                            onClick={handleFullscreenRequest}
                            style={{
                                color: "white",
                                backgroundColor: "#ff0066",
                                border: "none",
                                padding: "0.4rem 0.8rem",
                                textTransform: "capitalize",
                                borderRadius: "20px",
                                cursor: "pointer",
                            }}
                        >
                            Switch
                        </button>
                    </div>
                </DialogActions>
            </Dialog>
            {
                isInLandscapeMode === "portrait-primary" || isInLandscapeMode === "portrait-secondary" ?
                    (
                        <div
                            style={{
                                // backgroundColor: "#427eea",
                                opacity: "0.8",
                                height: "100svh",
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                flexDirection: "column",
                                justifyContent: "center",
                            }}
                        >
                            <div style={{
                                height: "9rem",
                                width: "9rem",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "#F2F2F7",
                                borderRadius: "50%"
                            }}>
                                <img
                                    src={landscape}
                                    alt="Landscape GIF"
                                    style={{
                                        height: "4rem",
                                        // animation: "tiltDown 1s ease infinite alternate",
                                    }}
                                />
                            </div>
                            <h3
                                style={{
                                    // color: "#fff",
                                    marginTop: "1rem",
                                    textAlign: "center",
                                    marginBottom: "0.5rem",
                                    wordWrap: "break-word",
                                }}
                            >
                                PLEASE ROTATE YOUR DEVICE
                            </h3>
                            <h6
                                style={{
                                    // color: "#fff",
                                    padding: "0 1rem",
                                    textAlign: "center",
                                    wordWrap: "break-word",
                                }}
                            >
                                Turn on auto-rotation as picture needs to be captured in landscape
                                mode.
                            </h6>
                        </div>
                    ) :
                    showImage ? (
                        <div
                            style={{
                                width: "100%",
                                height: "100svh",
                                zIndex: 100,
                                position: "absolute",
                                backgroundColor: "black",
                                backgroundImage: image ? `url(${URL.createObjectURL(image)})` : "",
                                backgroundSize: "contain",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center",
                            }}
                            onClick={() => setShowImage(!showImage)}
                        />
                    ) :
                        (
                            <>
                                {showInstructionPage ? <Photo_Video_Instruction setShowInstructionPage={setShowInstructionPage} /> :
                                    <>
                                        {/* CURRENT IMAGE TITLE */}
                                        {/* <Typography
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                padding: "8px 8px",
                                                gap: "10px",
                                                position: "absolute",
                                                width: "auto",
                                                height: "33px",
                                                left: "15px",
                                                top: "24px",
                                                background: "rgba(255, 255, 255, 0.6)",
                                                borderRadius: "8px",
                                                fontFamily: "'Montserrat', sans-serif",
                                                fontStyle: "normal",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                lineHeight: "157%",
                                                textAlign: "center",
                                                letterSpacing: "0.1px",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                color: "black",
                                                zIndex: 100,
                                                "@media (max-width: 900px)and (orientation: landscape)": {
                                                    fontSize: "12px",
                                                },
                                            }}
                                        >

                                            {currentImageTitle.viewName === "Selfie" ? `Take Selfie with the car` : currentImageTitle.viewName === `RPM Meter Video` || currentImageTitle.viewName === "Engine Video" ? `Take ${currentImageTitle.viewName} of the car` : `Take photo of the ${currentImageTitle.viewName} of the car`}

                                        </Typography> */}
                                        {/* PROGRESS BAR */}
                                        <Box
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                padding: "8px 8px",
                                                gap: "10px",
                                                position: "absolute",
                                                width: "auto",
                                                height: "38px",
                                                right: "100px",
                                                top: "24px",
                                                background: "rgba(255, 255, 255, 0.6)",
                                                borderRadius: "8px",
                                                fontFamily: "'Montserrat', sans-serif",
                                                fontStyle: "normal",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                lineHeight: "157%",
                                                textAlign: "center",
                                                letterSpacing: "0.1px",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                color: "black",
                                                zIndex: 100,
                                            }}
                                        >
                                            <ImageProgressBarRetake />
                                        </Box>
                                        {/* IMAGE ICON */}
                                        {/* Render the icon only if `isIconVisible` is true */}
                                        {/* {isIconVisible && !imageCaptured && !videoCaptured ? (
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    position: "absolute",
                                                    top: "50%",
                                                    left: "50%",
                                                    transform: "translate(-50%, -50%)",
                                                    zIndex: 101,
                                                    width: "150px",
                                                    height: "150px",
                                                    background: "rgba(255, 255, 255, 0.4)",
                                                    borderRadius: "50%",
                                                    "@media (max-width: 900px)": {
                                                        width: "100px",
                                                        height: "100px",
                                                    },
                                                }}
                                            >
                                                <img
                                                    src={imagePaths[currentImageTitle.imageName]}
                                                    alt={currentImageTitle.viewName}
                                                    style={{
                                                        // maxWidth: "100%",
                                                        // maxHeight: "100%",
                                                        width: "80px",
                                                        height: "80px",
                                                        "@media (max-width: 900px)": {
                                                            width: "100px",
                                                            height: "100px",
                                                        },
                                                    }}
                                                />
                                            </Box>
                                        ) : null
                                        } */}
                                        {/* SUGGESTION FOR LIGHTING */}
                                        {/* {(suggestion && (!imageCaptured || !videoCaptured)) && (
                                            <Typography
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    padding: "8px 8px",
                                                    gap: "10px",
                                                    position: "absolute",
                                                    width: "auto",
                                                    height: "33px",
                                                    left: "15px",
                                                    bottom: "30px",
                                                    background: "rgba(255, 255, 255, 0.6)",
                                                    borderRadius: "8px",
                                                    fontFamily: "'Montserrat', sans-serif",
                                                    fontStyle: "normal",
                                                    fontWeight: 500,
                                                    fontSize: "13px",
                                                    lineHeight: "157%",
                                                    textAlign: "center",
                                                    letterSpacing: "0.1px",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    color: "black",
                                                    zIndex: 100,
                                                    "@media (max-width: 900px)and (orientation: landscape)": {
                                                        fontSize: "12px",
                                                    },
                                                }}
                                            >
                                                {suggestion}
                                            </Typography>
                                        )} */}
                                        {/* CAMERA STEPS(TOP-RIGHT CORNER) */}
                                        {/* <div>
                                            {!isModalVisible && (
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        right: '2rem',
                                                        top: '24px',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        padding: '0.2rem 0.8rem',
                                                        zIndex: 2000,
                                                        background: 'rgba(255, 255, 255, 0.9)',
                                                        borderRadius: '10px',
                                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                                        backdropFilter: 'blur(10px)',
                                                    }}
                                                >
                                                    <img
                                                        src={cameraOption}
                                                        alt="Camera Option"
                                                        style={{
                                                            cursor: 'pointer',
                                                            width: '2rem',
                                                            height: '2rem',
                                                            transition: 'transform 0.3s ease, filter 0.3s ease',
                                                        }}
                                                        onClick={openCameraOption}
                                                        onMouseOver={(e) => {
                                                            e.currentTarget.style.transform = 'scale(1.15)';
                                                            e.currentTarget.style.filter = 'brightness(1.2)';
                                                        }}
                                                        onMouseOut={(e) => {
                                                            e.currentTarget.style.transform = 'scale(1)';
                                                            e.currentTarget.style.filter = 'brightness(1)';
                                                        }}
                                                    />
                                                </div>
                                            )}

                                            <Modal footer={null} open={isModalVisible} onCancel={handleCancel}
                                                //  width={800}
                                                className="inspection-steps-modal"
                                                bodyStyle={{
                                                    padding: '0',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    height: 'auto',
                                                    overflowY: 'auto',
                                                    position: 'relative',
                                                    //   maxWidth: '90vw',  // Maximum width of the modal
                                                    width: 'auto',
                                                }}
                                                style={{
                                                    //   position: 'fixed',
                                                    top: '24px',
                                                    right: '0rem',
                                                    zIndex: 2000,

                                                }}
                                            >
                                                <div style={{ flex: 1, overflow: 'auto' }}>
                                                    <InspectionSteps />
                                                </div>
                                            </Modal>
                                        </div> */}
                                        {/* camera container */}
                                        <div
                                            className="image-page"
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                width: windowDimensions.width,//"100%",
                                                height: windowDimensions.height,//"100svh",
                                                display: imageCaptured || videoCaptured ? "none" : "flex"
                                                // position: "relative",
                                            }}
                                            ref={containerRef}
                                        >
                                            {/* camera */}
                                            <div
                                                className="webcam-container"
                                                style={{
                                                    width: "100vw",
                                                    height: "100svh", // Use safe viewport height for better compatibility
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    backgroundColor: "black", // For letterboxing effect
                                                    overflow: "hidden",
                                                    position: "relative",
                                                }}
                                            >
                                                {/* <div
                                                    style={{
                                                        position: "absolute",
                                                        top: "5px",
                                                        left: "50%",
                                                        transform: "translateX(-50%)",
                                                        zIndex: 10,
                                                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                                                        color: "white",
                                                        padding: "5px 10px",
                                                        borderRadius: "5px",
                                                        height: "20px",
                                                        fontSize: "0.8rem",
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    {zoomLevel !== "!" ? `Zoom: ${zoomLevel}x` : "Zoom not detected"}
                                                </div> */}
                                                {console.log("userrid sbubham: ", userId)}
                                                <Webcam
                                                    // audio={userId !== 'UID101' && userId !== 'USR_291628'}
                                                    audio={!!userId && userId !== 'UID101' && userId !== 'USR_291628'}

                                                    muted={true}
                                                    mirrored={false}
                                                    ref={webcamRef}
                                                    height="100%"
                                                    width="100%"
                                                    screenshotFormat="image/jpeg"
                                                    screenshotQuality={1}
                                                    videoConstraints={videoConstraintsRef.current}
                                                    // videoConstraints={{
                                                    // 	width: 1920, // Match standard high resolution
                                                    // 	height: 1080,
                                                    // 	aspectRatio: 16 / 9, // Force aspect ratio
                                                    // }}                  
                                                    className="webcam"
                                                    style={{
                                                        position: "absolute",
                                                        textAlign: "center",
                                                        zIndex: 8,
                                                        right: 0,
                                                        left: 0,
                                                        top: 0,
                                                        bottom: 0,
                                                        objectFit: "contain", // Ensures full feed is visible with letterboxing
                                                        backgroundColor: "black", // Background to simulate letterboxing
                                                    }}
                                                />
                                            </div>
                                            {/* for network toast message */}
                                            <ToastContainer />

                                            {/* VIDEO TIMER FOR RPM METER */}
                                            <div style={{
                                                position: 'absolute',
                                                right: '50%',
                                                top: '50%',
                                                transform: 'translate(50%, -50%)',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                padding: '0.5rem 1rem',
                                                zIndex: 2000,
                                                color: "white",
                                                fontSize: "1.5rem",
                                                borderRadius: "50%",
                                            }}>
                                                {timerRef.current - 1 <= 5 && <VideoTimer number={timerRef.current - 1} />}
                                            </div>
                                            {!btnType &&
                                                <Typography
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        padding: "8px 8px",
                                                        gap: "10px",
                                                        position: "absolute",
                                                        width: "auto",
                                                        height: "33px",
                                                        right: "15px",
                                                        top: "100px",
                                                        background: "rgba(255, 255, 255, 0.6)",
                                                        borderRadius: "8px",
                                                        fontFamily: "'Montserrat', sans-serif",
                                                        fontStyle: "normal",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        lineHeight: "157%",
                                                        textAlign: "center",
                                                        letterSpacing: "0.1px",
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        color: "black",
                                                        zIndex: 100,
                                                        "@media (max-width: 900px)and (orientation: landscape)": {
                                                            fontSize: "12px",
                                                        },
                                                    }}
                                                >
                                                    {formatTime(timerRef.current - 1)}
                                                </Typography>
                                            }
                                            {/* capture button */}
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    right: "1.5rem",
                                                    height: "100svh",
                                                    display: "flex",
                                                    justifyContent: "flex-end",
                                                    flexDirection: "column",
                                                    gap: "1rem",
                                                    top: "44px",
                                                    zIndex: 2000,
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        // position: "relative",
                                                        // bottom: "60px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        height: "100svh"
                                                    }}
                                                >
                                                    {currentImageTitle.mode === "photo" ?
                                                        <button style={buttonStyle} onClick={capturePhoto}>
                                                            <div style={innerCircleStyle}></div>
                                                        </button>
                                                        : <div style={buttonStyle} onClick={btnType ? handleStartCaptureClick : handleStopCaptureClick}>
                                                            <div style={{ ...innerCircleStyle, backgroundColor: btnType ? "green" : "#F44336" }}></div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        {imageCaptured && (
                                            <div
                                                style={{
                                                    width: "100vw",
                                                    height: "100svh",
                                                    overflow: "hidden",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    backgroundColor: "black",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        top: "60%",
                                                        // // right: "1.5rem",
                                                        transform: "translateY(-50%)",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignContent: "center",
                                                        justifyContent: "center",
                                                        gap: "6rem",

                                                        // bottom: "20px"
                                                    }}
                                                >
                                                    {currentImageTitle.mode === "photo" ?
                                                        <>
                                                            <CustomToastify />
                                                            <button style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.2rem", border: "1.5px solid #FC350B", padding: "0rem 1.2rem", backgroundColor: "white", borderRadius: "5px", opacity: "0.9" }}>
                                                                <img src={correct} style={{ width: "1rem", height: "1rem" }}></img>
                                                                <p style={{ fontSize: "1rem", fontFamily: "'Montserrat', sans-serif", color: "#FC350B", padding: "0.5rem", cursor: "pointer" }} onClick={handleFinishRetakeImages}>Finish Retake</p>
                                                            </button>
                                                        </>
                                                        // <>
                                                        //     <CustomToastify />
                                                        //     <button style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.2rem", border: "1.5px solid #FC350B", padding: "0rem 1.2rem", backgroundColor: "white", borderRadius: "5px", opacity: "0.9" }}>
                                                        //         <img src={reload} style={{ width: "1rem", height: "1rem" }}></img>
                                                        //         <p style={{ fontSize: "1rem", fontFamily: "'Montserrat', sans-serif", color: "#FC350B", padding: "0.5rem", cursor: "pointer" }} onClick={handleRetakeClick}>Retake</p>
                                                        //     </button>
                                                        // </>
                                                        :
                                                        < >
                                                            <CustomVideoToastify />
                                                            <button style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.2rem", border: "1.5px solid #FC350B", padding: "0rem 1.2rem", backgroundColor: "white", borderRadius: "5px", opacity: "0.9" }}>
                                                                <img src={reload} style={{ width: "1rem", height: "1rem" }}></img>
                                                                <p style={{ fontSize: "1rem", fontFamily: "'Montserrat', sans-serif", color: "#FC350B", padding: "0.5rem", cursor: "pointer" }}
                                                                    onClick={handleRetakeForVideo}
                                                                >Retake</p>
                                                            </button>
                                                        </>//useless
                                                    }
                                                </div>
                                                {/* image preview */}
                                                {currentImageTitle.mode === "photo" &&
                                                    <img
                                                        src={URL.createObjectURL(image)}
                                                        alt="Captured"
                                                        style={{
                                                            width: "100%",
                                                            height: "100%",
                                                            objectFit: "contain"    //changed 
                                                        }}
                                                    />
                                                }
                                            </div>
                                        )}
                                        {/* after rpm meter vdo is captured */}
                                        {videoCaptured && (
                                            <div
                                                style={{
                                                    width: "100vw",
                                                    height: "100svh",
                                                    overflow: "hidden",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    backgroundColor: "black",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        top: "60%",
                                                        // // right: "1.5rem",
                                                        transform: "translateY(-50%)",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignContent: "center",
                                                        justifyContent: "center",
                                                        gap: "6rem",

                                                        // bottom: "20px"
                                                    }}
                                                >
                                                    {currentImageTitle.mode === "photo" ?
                                                        <>
                                                            <CustomToastify />
                                                            <button style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.2rem", border: "1.5px solid #FC350B", padding: "0rem 1.2rem", backgroundColor: "white", borderRadius: "5px", opacity: "0.9" }}>
                                                                <img src={reload} style={{ width: "1rem", height: "1rem" }}></img>
                                                                <p style={{ fontSize: "1rem", fontFamily: "'Montserrat', sans-serif", color: "#FC350B", padding: "0.5rem", cursor: "pointer" }} onClick={handleRetakeClick}>Retake</p>
                                                            </button>
                                                        </> :
                                                        < >
                                                            <CustomVideoToastify />
                                                            <button style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.2rem", border: "1.5px solid #FC350B", padding: "0rem 1.2rem", backgroundColor: "white", borderRadius: "5px", opacity: "0.9" }}>
                                                                <img src={reload} style={{ width: "1rem", height: "1rem" }}></img>
                                                                <p style={{ fontSize: "1rem", fontFamily: "'Montserrat', sans-serif", color: "#FC350B", padding: "0.5rem", cursor: "pointer" }}
                                                                    onClick={handleRetakeForVideo}
                                                                >Retake</p>
                                                            </button>
                                                        </>
                                                    }
                                                </div>

                                                {currentImageTitle.mode === "photo" &&
                                                    <img
                                                        src={URL.createObjectURL(image)}
                                                        alt="Captured"
                                                        style={{
                                                            width: "100%",
                                                            height: "100%",
                                                            objectFit: "cover"
                                                        }}
                                                    />
                                                }
                                            </div>
                                        )}
                                    </>
                                }
                            </>
                        )
            }

            <SnackbarAlert />
        </div >
    );
};

export default CameraRetake;
